import { FunctionComponent } from "react";

import { ConfirmTransferScreenProps } from "../useConfirmTransfer";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";

import Spacing from "../../../layout/spacing";
import validateName from "../../../utils/validateName";
import { TitleLarge, BodyLargeRegular } from "../../../components/font";
import { Button, TextField, tokens } from "@manifesthhqinc/ui-library";
import { FormContainer } from "../../destination-account/screens/styles";
import HeadingContainer from "../../../layout/heading-container";
import formatBirthday from "../../../utils/formatBirthday";

const SpousalInfo: FunctionComponent<ConfirmTransferScreenProps> = (props: ConfirmTransferScreenProps) => {
  const { userDetails, updateUserDetails, validation, validateField, onClickContinue } = props;

  const handleNameChange = (name: string, value: string) => {
    if (validateName(value)) {
      updateUserDetails({ [name]: value });
    } else {
      // ignore input if it's not alphabetic characters, spaces, hyphens, apostrophes, and accented characters
    }
  };

  return (
    <TransitionWrapper>
      <ScrollableContainer name="confirm-transfer-screen-spousal-info">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge $textAlign="left">Your spousal information</TitleLarge>
            <BodyLargeRegular $color={tokens.color.text.secondary}>
              Some providers need a signature from your spouse for transfers. We’ll confirm this for you and let you
              know if it’s needed.
            </BodyLargeRegular>
          </HeadingContainer>
          <FormContainer>
            <TextField
              value={userDetails.spouseName}
              name="personal-details-spouse-name"
              title="Spouse's full name"
              onChange={(e) => handleNameChange("spouseName", e.target.value)}
              onBlur={() => validateField("spouseName")}
              errorText={(validation?.spouseName as string) || undefined}
              isError={Boolean(validation?.spouseName)}
              size="large"
            />
            <TextField
              value={userDetails.spouseEmail}
              name="personal-details-spouse-email"
              title="Spouse's email"
              onChange={(e) => updateUserDetails({ spouseEmail: e.target.value })}
              onBlur={() => validateField("spouseEmail")}
              errorText={(validation?.spouseEmail as string) || undefined}
              isError={Boolean(validation?.spouseEmail)}
              placeholder="spouse@email.com"
              size="large"
            />
            <TextField
              isPhoneNumber
              value={userDetails.spousePhoneNumber}
              name="personal-details-spouse-phone"
              title="Spouse's mobile phone"
              onPhoneNumberChange={(e) => {
                updateUserDetails({ spousePhoneNumber: e });
              }}
              onBlur={() => validateField("spousePhoneNumber")}
              errorText={(validation?.spousePhoneNumber as string) || undefined}
              isError={Boolean(validation?.spousePhoneNumber)}
              placeholder="(234) 567 8900"
              size="large"
            />
            <TextField
              value={userDetails.spouseDateOfBirth ? formatBirthday(userDetails.spouseDateOfBirth) : ""}
              name="personal-details-spouse-date-of-birth"
              title="Spouse's date of birth"
              type={"date"}
              onChange={(e) => updateUserDetails({ spouseDateOfBirth: e.target.value })}
              onBlur={() => validateField("spouseDateOfBirth")}
              errorText={(validation?.spouseDateOfBirth as string) || undefined}
              isError={Boolean(validation?.spouseDateOfBirth)}
              inputMode="numeric"
              size="large"
            />
          </FormContainer>
          <Spacing vertical="16" />
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default SpousalInfo;
